import { Box } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import AccountIcon from "../../assets/images/icons/AccountIcon.tsx";
import { DashboardIcon } from "../../assets/images/icons/DashboardIcon";
import NotesIcon from "../../assets/images/icons/NotesIcon.tsx";
import LinkConstants from "../../constants/LinkConstants";
import RouterConstants from "../../constants/RouterConstants";
import { useAppStore } from "../../hooks/useStores.tsx";
import CommunityButton from "./CommunityButton.tsx";
import GetHelpButton from "./GetHelpButton.tsx";
import styles from "./Sidebar.module.scss";
import SidebarButton from "./SidebarButton";
import SidebarSection from "./SidebarSection";

function Sidebar() {
	const { uiStore } = useAppStore();
	const { t } = useTranslation("translation", { keyPrefix: "sideMenu" });

	return (
		<Box className={styles.sideBarContainer} ref={uiStore.sideBar}>
			<Box>
				<SidebarSection className={styles.mainSection} withDivider>
					<SidebarButton
						title={t("dashboard")}
						url={RouterConstants.CONSOLE.path}
						matchExact
						iconStart={DashboardIcon}
					/>
				</SidebarSection>

				<SidebarSection title={t("products")} className={styles.configSection} withDivider>
					<SidebarButton title={t("models")} url={RouterConstants.MODELS.fullPath} />
					<SidebarButton title={t("imageGeneration")} url={RouterConstants.IMAGE_GENERATION.fullPath} />
					<SidebarButton title={t("imageEditing")} url={RouterConstants.IMAGE_EDITING.fullPath} />
					<SidebarButton title={t("tailoredGeneration")} url={RouterConstants.NEW_TG.fullPath} />
					{/* <SidebarButton
						title={t("adsGeneration")}
						url={RouterConstants.ADS_GENERATION.fullPath}
						visible={
							authStore.isFeatureEnabled(OrgFeatures.CAMPAIGN) ||
							[
								isBriaOrg,
								isAwsOrg,
								isLoblawOrg,
								isPublicisOrg,
								isRakutenOrg,
								isAprimoOrg,
								isVmlOrg,
								isMiroglioOrg,
								isNexarOrg,
								isSaffronOrg,
								isTrailerParkGroupOrg,
							].some((fn) => fn())
						}
					/> */}

					<SidebarButton title={t("productShotEditing")} url={RouterConstants.PRODUCT_SHOT.fullPath} />
					{/* <SidebarButton title={t("videoEditing")} url={RouterConstants.VIDEO_EDITING.fullPath} /> */}
					<SidebarButton title={t("imageSearch")} url={RouterConstants.IMAGE_SEARCH.fullPath} />
				</SidebarSection>

				<SidebarSection>
					<SidebarButton title={t("playgroundHub")} url={RouterConstants.APPS.fullPath} newTab />
					<SidebarButton title={t("apiDocs")} url={LinkConstants.BRIA_API} newTab />
				</SidebarSection>
			</Box>

			<SidebarSection className={styles.footerButtonsContainer}>
				<SidebarButton
					title={t("myOrganization")}
					url={RouterConstants.ACCOUNT.fullPath}
					iconStart={AccountIcon}
					fullWidth={false}
				/>
				<SidebarButton
					title={t("termsAndConditions")}
					url={LinkConstants.LEGAL_LOBBY_LINK}
					iconStart={NotesIcon}
					newTab
					fullWidth={false}
				/>
				<CommunityButton />
				<GetHelpButton />
			</SidebarSection>
		</Box>
	);
}

export default observer(Sidebar);
